import { Platform } from 'react-native';

import { useLaunchDarklyFlag } from '@/hooks/flags/useLaunchDarklyFlag';

/**
 * Whether the Cards feature is available. It's gated behind the
 * `expo-flagship-cards` LaunchDarkly flag AND is native-only (iOS/Android) —
 * not available on web for now.
 */
export const useIsCardsEnabled = (): boolean => {
  const flagEnabled = useLaunchDarklyFlag('expo-flagship-cards', false);
  return flagEnabled && Platform.OS !== 'web';
};
